import { render, staticRenderFns } from "./MigrateInstrumentTable.vue?vue&type=template&id=368e9584&scoped=true&"
import script from "./MigrateInstrumentTable.vue?vue&type=script&lang=js&"
export * from "./MigrateInstrumentTable.vue?vue&type=script&lang=js&"
import style0 from "./MigrateInstrumentTable.vue?vue&type=style&index=0&id=368e9584&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368e9584",
  null
  
)

export default component.exports